import { api } from '../../lib/api';
import { T, useGym } from '../../lib/gym';
import { useApi } from '../../lib/hooks';
import { useI18n } from '../../lib/i18n';
import { Card, Empty, ErrorBox, Loading, PageHeader } from '../../ui/components';

/** What the coach shared with the client: the write-up and what they agreed together. */
export function MyCoachingPage() {
  const gym = useGym();
  const i18n = useI18n();
  const list = useApi(() => api<any[]>(`${T(gym.slug)}/me/coaching`), []);
  if (list.error) return <div className="page"><ErrorBox error={list.error} onRetry={list.reload} /></div>;
  if (!list.data) return <Loading />;
  return (
    <div className="page narrow">
      <PageHeader title={i18n.t('coaching.my_title')} subtitle={i18n.t('coaching.my_subtitle')} />
      {list.data.length === 0 ? <Empty icon="🗣">{i18n.t('coaching.my_none')}</Empty> : list.data.map((c) => (
        <Card key={c.id} title={c.title || i18n.t(`coaching.kind_${c.kind}`)} actions={<span className="small muted">{i18n.date(c.heldAt)}</span>}>
          {c.summary && <p className="pre">{c.summary}</p>}
          {(c.actions ?? []).length > 0 && (
            <>
              <strong>{i18n.t('coaching.agreed')}</strong>
              <ul className="sets">{c.actions.map((a: string, i: number) => <li key={i}>{a}</li>)}</ul>
            </>
          )}
          {c.transcript && (
            <details>
              <summary>{i18n.t('coaching.transcript')}</summary>
              <p className="pre small">{c.transcript}</p>
            </details>
          )}
        </Card>
      ))}
      <p className="small muted">{i18n.t('coaching.my_help')}</p>
    </div>
  );
}
